import { c as _c } from "react/compiler-runtime";
import SettingsLayout from 'modules/profile/components/settings-layout';
import { settingsMenuLocoKeys } from 'modules/profile/constants/settings-menu-loco-keys';
import { ActiveCampaignIntegration, ActiveCampaignIntegrationComingSoon } from 'modules/profile/integrations/active-campaign-integration';
import { integrationsLoco } from 'modules/profile/integrations/constants/loco';
import { GoogleCalendarIntegration, GoogleCalendarIntegrationComingSoon } from 'modules/profile/integrations/google/calendar';
import { GoogleMeetIntegration, GoogleMeetIntegrationComingSoon } from 'modules/profile/integrations/google/meet';
import { GoogleSheetsIntegration, GoogleSheetsIntegrationComingSoon } from 'modules/profile/integrations/google/sheets';
import { TwilioIntegration } from 'modules/profile/integrations/twilio';
import { ZoomIntegration, ZoomIntegrationComingSoon } from 'modules/profile/integrations/zoom';
import { getHostOnServerServerSideProps, HostOnServerInterface } from 'modules/white-label/util/get-host-on-server';
import { NextPage } from 'next';
import { useState } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { getBaseServerSideProps, getCombinedServerSideProps } from 'shared/utils/get-base-server-side-props';
import { isSIO } from 'shared/utils/is-sio';
const Integrations: NextPage<HostOnServerInterface> = t0 => {
  const $ = _c(27);
  const {
    hostOnServer
  } = t0;
  const {
    isWorkspaceOwner,
    isWsAdmin
  } = useUser();
  const {
    t
  } = useLocoTranslation();
  const [openedGoogleCalendarIntegration, setOpenedGoogleCalendarIntegration] = useState(false);
  let t1;
  if ($[0] !== hostOnServer) {
    t1 = isSIO(hostOnServer);
    $[0] = hostOnServer;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isSio = t1;
  let t2;
  if ($[2] !== t) {
    t2 = t(settingsMenuLocoKeys.integrations);
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = [{
      caption: t2,
      isStatic: true
    }];
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  let t5;
  let t6;
  if ($[6] !== isSio) {
    t4 = isSio ? <ZoomIntegration /> : <ZoomIntegrationComingSoon />;
    t5 = isSio ? <GoogleMeetIntegration onManageCalendar={() => {
      setOpenedGoogleCalendarIntegration(true);
    }} /> : <GoogleMeetIntegrationComingSoon />;
    t6 = isSio ? <GoogleSheetsIntegration /> : <GoogleSheetsIntegrationComingSoon />;
    $[6] = isSio;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t4 = $[7];
    t5 = $[8];
    t6 = $[9];
  }
  let t7;
  if ($[10] !== isSio || $[11] !== isWorkspaceOwner || $[12] !== isWsAdmin) {
    t7 = (isWorkspaceOwner || isWsAdmin) && (isSio ? <ActiveCampaignIntegration /> : <ActiveCampaignIntegrationComingSoon />);
    $[10] = isSio;
    $[11] = isWorkspaceOwner;
    $[12] = isWsAdmin;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== isSio || $[15] !== openedGoogleCalendarIntegration) {
    t8 = isSio ? <GoogleCalendarIntegration opened={openedGoogleCalendarIntegration} setOpened={setOpenedGoogleCalendarIntegration} /> : <GoogleCalendarIntegrationComingSoon />;
    $[14] = isSio;
    $[15] = openedGoogleCalendarIntegration;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <TwilioIntegration />;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t4 || $[19] !== t5 || $[20] !== t6 || $[21] !== t7 || $[22] !== t8) {
    t10 = <div><div className="flex flex-col flex-wrap gap-3 md:flex-row">{t4}{t5}{t6}{t7}{t8}{t9}</div></div>;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t10 || $[25] !== t3) {
    t11 = <SettingsLayout needSave={false} titles={t3}>{t10}</SettingsLayout>;
    $[24] = t10;
    $[25] = t3;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  return t11;
};
export const getServerSideProps = getCombinedServerSideProps(getBaseServerSideProps(integrationsLoco, 'global.settings'), getHostOnServerServerSideProps);
export default Integrations;